import { render, staticRenderFns } from "./AidTraining.vue?vue&type=template&id=36fbce1f&"
import script from "./AidTraining.vue?vue&type=script&lang=js&"
export * from "./AidTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports